import React from 'react';
import '../../styles/icone.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {chiaveSport, iconaDiChiave} from './icone';
import {coloreSport} from './coloriSport';

/* Le quattro che FontAwesome non ha. Disegnate semplici apposta: a 18px
   conta la sagoma, non il dettaglio. `currentColor` cosi' prendono il
   colore del testo accanto e seguono i colori della skin. */

const Cricket = (p) => (
  /* I tre pali con le due bacchette sopra: non si confonde con niente. */
  <svg viewBox={'0 0 24 24'} fill={'currentColor'} {...p}>
    <rect x={'4.6'} y={'6'} width={'2'} height={'13'} rx={'1'}/>
    <rect x={'11'} y={'6'} width={'2'} height={'13'} rx={'1'}/>
    <rect x={'17.4'} y={'6'} width={'2'} height={'13'} rx={'1'}/>
    <rect x={'4'} y={'4'} width={'8'} height={'1.6'} rx={'0.8'}/>
    <rect x={'12'} y={'4'} width={'8'} height={'1.6'} rx={'0.8'}/>
  </svg>
);

const Ovale = (p) => (
  /* Rugby e aussie rules: la palla ovale con la cucitura e i lacci. */
  <svg viewBox={'0 0 24 24'} fill={'currentColor'} {...p}>
    <path d={'M19.8 4.2C17.4 1.8 9.9 2.6 6.2 6.3 2.5 10 1.7 17.5 4.1 19.9'
      + 'c2.4 2.4 9.9 1.6 13.6-2.1 3.7-3.7 4.5-11.2 2.1-13.6zm-2.3 11.9'
      + 'c-2.7 2.7-8.2 3.6-9.9 1.9-1.7-1.7-.8-7.2 1.9-9.9 2.7-2.7 8.2-3.6'
      + ' 9.9-1.9 1.7 1.7.8 7.2-1.9 9.9z'}/>
    <path d={'M9.1 13.5l4.4-4.4 1.4 1.4-4.4 4.4z'}/>
    <path d={'M10.6 11.1l1.1 1.1.9-.9-1.1-1.1zm2 2l1.1 1.1.9-.9-1.1-1.1z'}/>
  </svg>
);

const Pallamano = (p) => (
  /* La palla a pannelli: cerchio con lo spicchio a sei lati dentro. */
  <svg viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'}
    strokeWidth={'1.8'} strokeLinejoin={'round'} {...p}>
    <circle cx={'12'} cy={'12'} r={'9'}/>
    <path d={'M12 7.4l3.2 1.9v3.8L12 15l-3.2-1.9V9.3z'}/>
    <path d={'M12 3v4.4M15.2 9.3l3.8-2.2M15.2 13.1l3.8 2.2'
      + 'M12 15v6M8.8 13.1L5 15.3M8.8 9.3L5 7.1'}/>
  </svg>
);

const Tennis = (p) => (
  /* La pallina con le due curve: non la racchetta del ping-pong. */
  <svg viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'}
    strokeWidth={'1.9'} strokeLinecap={'round'} {...p}>
    <circle cx={'12'} cy={'12'} r={'9'}/>
    <path d={'M5.2 6.1c3.4 3.3 3.4 8.5 0 11.8M18.8 6.1c-3.4 3.3-3.4 8.5 0 11.8'}/>
  </svg>
);

const DISEGNI = {
  tennis: Tennis,
  cricket: Cricket,
  rugby: Ovale,
  aussie: Ovale,
  pallamano: Pallamano,
};

/**
 * L'icona di uno sport.
 *
 * sport:     l'oggetto sport del catalogo (serve `icon`, `name`, `color`)
 * className: la classe della riga in cui sta, per le misure
 * colore:    forza un colore, per quando l'icona sta SOPRA il colore dello
 *            sport (l'intestazione al centro) e deve restare bianca
 *
 * Il colore e' quello della disciplina (coloriSport.js, dai valori del PSD),
 * lo stesso che colora la barretta della riga nel menu e il fondo della riga
 * scelta: cosi' si muovono insieme. Il campo `color` del catalogo ha la
 * precedenza se c'e', per il giorno in cui il backoffice dara' a ogni sport
 * il suo — ma oggi non c'e' piu': mandava #22b8cf per tutti, ed e' per questo
 * che si vedevano tutti uguali.
 */
class IconaSport extends React.Component {
  render() {
    const {sport, className, title, colore} = this.props;
    const chiave = chiaveSport(sport);
    const nome = title || (sport && sport.name) || '';
    const classi = 'lvc-icona-sport' + (className ? ' ' + className : '');
    /* Il colore: quello imposto da chi disegna, poi quello del catalogo se
       un giorno ne mandera' uno vero per sport, e infine quello della
       disciplina. Il catalogo mandava "#22b8cf" per TUTTI - come dice il
       commento qui sopra, scritto da chi se n'era gia' accorto - ed e' stato
       tolto di la': adesso la riga e l'icona prendono la stessa tinta, dallo
       stesso posto. */
    const scelto = colore || coloreSport(sport);
    const stile = scelto ? {color: scelto} : undefined;

    const Disegno = DISEGNI[chiave];
    if (Disegno) {
      return (
        <Disegno className={classi} style={stile} role={'img'}
          aria-label={nome} focusable={'false'}/>
      );
    }

    return (
      <FontAwesomeIcon
        icon={iconaDiChiave(chiave)}
        className={classi}
        style={stile}
        title={nome}
      />
    );
  }
}

export default IconaSport;
